import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { feedbackReducer } from './feedback.reducer';
import { FeedbackEffects } from './feedback.effects';

/**
 * Feedback State Module
 * 
 * This module registers the feedback feature state with NgRx.
 * Import this module in StateModule to activate feedback state management.
 */
@NgModule({
  imports: [
    StoreModule.forFeature('feedback', feedbackReducer),
    EffectsModule.forFeature([FeedbackEffects])
  ]
})
export class FeedbackStateModule {}
